<header class="bg-brand-header fixed-top d-flex">
  <div class="container-fluid">
    <div class="row">
      <div class="col py-0">
        <nav class="navbar navbar-expand-lg navbar-light">
          @if (showMenuToggler$ | async) {
            <div class="toogle-menu">
              <button
                [ngbPopover]="menuTooltip() | translate"
                placement="right"
                triggers="mouseenter:mouseleave"
                class="p-0 d-flex justify-content-center align-items-center"
                type="button"
                (click)="toggleMenu()">
                <i class="pbi-icon-mini" [class]="isMenuOpen() ? 'pbi-text-margin-right' : 'pbi-text-margin-left'"></i>
              </button>
            </div>
          }
          @if (authentificationService.isLoggedIn() && userService.isOxyane()) {
            <a [routerLink]="appRoutes.Welcome">
              <img class="logo-oxyane" src="assets/images/logo_oxyane.png" alt="DigiDoc" />
            </a>
          }
          @if (authentificationService.isLoggedIn() && userService.isFidal()) {
            <nav class="custom-navbar cursor-pointer" [routerLink]="appRoutes.Welcome">
              <span class="navbar-brand brand-title"> Pitney Bowes </span>
              <img src="assets/images/logoCross.png" alt="X" />
              <span class="custom-navbar-brand fidal-link-bg" aria-label="Fidal ePoste Logo" role="img"></span>
            </nav>
          }

          @if (authentificationService.isLoggedIn() && !userService.isFidal() && !userService.isOxyane()) {
            <a class="navbar-brand" data-testid="header-brand-link" [routerLink]="appRoutes.Welcome">
              {{ 'core.header.title' | translate }}
            </a>
          }

          @if (!authentificationService.isLoggedIn()) {
            <span class="navbar-brand" [routerLink]="appRoutes.Welcome"></span>
          }

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto"></ul>
            <ul class="navbar-nav navbar-right d-flex align-items-center">
              @if (userService.isSuperUser()) {
                <li class="nav-item d-flex align-items-center justify-content-center mr-2">
                  <app-icon
                    [title]="'customer-account.change-account' | translate"
                    iconName="people_alt"
                    iconType="material"
                    [isClickable]="true"
                    (clicked)="openImpersonationModal()"
                    customClass="text-white" />
                </li>
              }

              <app-language-switcher />

              @if (authentificationService.isLoggedIn()) {
                <li class="nav-item menu-help" [matMenuTriggerFor]="dropDownHelp.menu">
                  <button class="nav-link" aria-labelledby="help-offscreen" aria-haspopup="true" aria-expanded="false">
                    <span class="d-inline-block ms-2">{{
                      (userService.isFidal() ? 'core.header.fidalhelp' : 'core.header.help') | translate
                    }}</span>
                    <span class="d-lg-none" id="help-offscreen">
                      <i class="pbi-icon-mini pbi-help-circle" aria-hidden="true"></i>&nbsp;
                      {{ 'core.header.support' | translate }}
                    </span>
                  </button>
                </li>
                <!-- User menu -->
                <li class="nav-item menu-user" [matMenuTriggerFor]="dropDownUser.menu">
                  <button
                    class="nav-link"
                    aria-labelledby="username-offscreen"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <span class="d-lg-none" id="username-offscreen">
                      <i aria-hidden="true" class="pbi-icon-outline pbi-user"></i>
                    </span>
                    <span class="d-none d-lg-block header-user-lockup" data-testid="header-user-email">{{
                      userService.userMail()
                    }}</span>
                  </button>
                </li>
              }
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
  @if (!IsProdEnv) {
    <div class="env-badge bg-{{ envName }} px-1">{{ envName }}</div>
  }
</header>

<app-dropdown-menu #dropDownHelp identifier="help-menu" [menuItems]="menuItemHelp()" />
<app-dropdown-menu #dropDownUser identifier="user-menu" [menuItems]="menuItemUser" />
